import { QueryClient } from '@tanstack/react-query'

// Single shared QueryClient. Tuned for an admin-heavy app where stale-while-
// revalidate is fine for most reads but mutations should always force a refetch.
// First reference implementation lives alongside Leaderboards / UserManagement;
// remaining pages migrate opportunistically (per Phase 1 plan W5).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
})
